
































































































































































































































































































































































































































































































































































































import { ContextMenu } from '../../core/components';
import ModalConfirmation from '../../home/components/ModalConfirmation.vue';
import ModalJourneyABM from '../../home/components/ModalJourneyABM.vue';
import EventsSection from '../components/EventsSection.vue';
import JourneyReports from '../components/JourneyReports.vue';
import JourneyOTList from '../components/JourneyOTList.vue';
import { Destroyed, Mounted } from '../../core/decorators';
import { PageTitle } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
// import { ModifyJourney } from '../components';
import { addTimeToDate, formatDate, getCurrentTime, getDateAsMoment, getDateFormattedAsMoment, getIndexFromList, ID, PRIVILEGE_KEYS, PRIVILEGE_TYPES, removeItemFromLocalStorage, StoregeKey } from '../../core/utils';
import { generateExcel } from '../index';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { dateTypes, Privileges, TypeFilterDate } from '../../core/models';
import { JourneysService } from '../../journeys/api/JourneysService';
import { SettingsService } from '../../settings/api/SettingsService';
import Axios from 'axios';
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { EventBus, TypeEventBus, sortObjectByPropertyName } from '../../core/utils';
import moment from 'moment';
import { JourneyReportsDict, JourneyStateReport } from '../models/JourneyInfo';

@Component({
    // components: { ModifyJourney, Loading }
    components: {
        Loading,
        ModalConfirmation,
        ModalJourneyABM,
        EventsSection,
        PageTitle,
        ContextMenu,
        SimpleTable,
        JourneyReports,
        JourneyOTList
    }
})
export default class JourneyPage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    journeyReports:JourneyStateReport | null = null;
    journeyCalcType: ID = -1;
    defaultFormData: any = {
        driver: '',
        vehicle: null,
        dateStart: null,
        dateEnd: null,
        hourEnd: null,
        simpleHours: {
            hours: null,
            minutes: null
        },
        nightHours: {
            hours: null,
            minutes: null
        },
        extraHours: {
            hours: null,
            minutes: null
        },
        simplePresentHours: {
            hours: null,
            minutes: null
        },
        overnightHours: {
            hours: null,
            minutes: null
        },
        simpleSpecialHours: {
            hours: null,
            minutes: null
        },
        simpleRestHours: {
            hours: null,
            minutes: null
        },
        extraSpecialHours: {
            hours: null,
            minutes: null
        },
        stoppedTimeHours: {
            hours: null,
            minutes: null
        },
        extraRestHours: {
            hours: null,
            minutes: null
        },
        closed_segments: [],
        summary: {},
    };
    formData: any = this.defaultFormData;
    periods: any = [];
    inconsistency: boolean = false;
    journeyIsClosing: boolean = false;
    actualTimeStamp: any = getCurrentTime(dateTypes.dateFormatFromDisplayInfoNoSeconds)
    fechaTentativa: string = '';
    hoursList: any = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
    ];
    modalForzarCierreInfo: object = {
        width: '600',
        title: 'Forzar Cierre',
        form: {
            action: 'forzar-cierre'
        },
        warning: {
            icon: 'mdi-alert',
            text: '<b>ADVERTENCIA</b>: ESTA ACCIÓN NO PUEDE REVERTIRSE'
        },
        isClosing: this.journeyProcessingClosing,
        actions: [
            {
                name: 'Cancelar',
                color: 'error',
                action: 'close-modal'
            },
            {
                name: 'Forzar Cierre',
                color: 'green',
                action: 'forceCloseJourney'
            }
        ]
    };
    modalJourneyVisibility: boolean = false;
    journeyDeleted: boolean = false;
    modalEditarDatos: any = {
        width: '1000',
        title: 'Modificar Jornada',
        disclaimers: [
            'La modificacion de la jornada por parte de la administración es responsabilidad de la misma.<br> Smartway no se responsabiliza por la consistencia de las jornadas a modificar, anteriores o posteriores.'
        ],
        form: {
            action: 'edit',
            data: this.getFormData
        },
        actions: [
            {
                name: 'Cancelar',
                color: 'error',
                action: 'close-modal'
            },
            {
                name: 'Aplicar modificación',
                color: 'green',
                action: 'modifyJourney'
            }
        ]
    };
    defaultTimeValue: string = '00H00M00S';

    contextMenuItem: any = [];
    rightClickEvent: any = null;
    showContextMenu: boolean = false;

    company: string = '';

    postJson: object = {};
    pendingRequest: boolean = true;
    processingExcel: boolean = false;
    search: string = '';
    journeyEvents: any = '';
    actionJourney: string = '';
    showModalAbm: boolean = false;
    showActions: boolean = false;
    journeyStatus: boolean = false;
    processingRequest: boolean = false;
    processingRequestMark: boolean = false;
    journeyCompanyId: number = -1;
    journeyFinished: boolean = false;
    vehicleSelected: string = '';
    // journeyHasError: boolean = false;
    showModifyJourney: boolean = false;
    showModalConfirmation: boolean = false;
    cancelToken: any = null;
    active: boolean = false;
    journeyCreatedByAdmin: boolean = false;
    journeyDateEnd: any = null;
    backupJourneyInformation: object = {};
    statsMock: any = {
        stats: {
            stat_0: {
                tooltip: 'Suma de las distancias recorridas de todos los veh\u00edculos',
                description: 'Distancia Recorrida (km)',
                value: 979.0
            },
            stat_1: {
                tooltip: 'Velocidad media sin ralenti promedio de todos los veh\u00edculos seleccionados',
                description: 'Velocidad Media sin Ralenti (km/h)',
                value: 47.39
            },
            stat_2: {
                tooltip: 'Suma de las horas operacionales totales de todos los veh\u00edculos',
                description: 'Horas Encendido (h)',
                value: 23.0
            }
        }
    };
    stops: any = [];
    journeyHasPernocte: boolean = false;
    reprocessAlert: object | null = null;

    summary: any = {};

    stats: any = {};
    deletedTooltip: string = 'Jornada eliminada por administración';
    hours: any = {};

    headersAlarms: any[] = [
        {
            text: 'Nombre',
            align: 'left',
            value: 'name'
        },
        { text: 'Valor', value: 'value', align: 'center' },
        { text: 'Fecha', value: 'datetime', align: 'center' }
    ];

    alarms: any = [
        {
            name: 'Alarma 1',
            value: '50',
            datetime: '21/01/2019 a las 15:30'
        }
    ];

    alerts: any = {
        count: null,
        messages: [
            {
                description: 'Tiempo excesivo de parada',
                value: '06H22M10S',
                suffix: 'detenido'
            },
            {
                description: 'Tiempo excesivo de jornada',
                value: '512H22M10S',
                suffix: 'de trabajo'
            },
            {
                description: 'Uso de tag generica',
                value: '124124',
                suffix: ''
            },
            {
                description: 'Tiempo excesivo de parada',
                value: '12H22M10S',
                suffix: 'detenido'
            },
            {
                description: 'Tiempo excesivo de jornada',
                value: '512H22M10S',
                suffix: 'de trabajo'
            },
            {
                description: 'Tiempo excesivo de parada',
                value: '06H22M10S',
                suffix: 'detenido'
            },
            {
                description: 'Tiempo excesivo de jornada',
                value: '01H22M10S',
                suffix: 'de trabajo'
            }
        ]
    };

    headersAlerts: any[] = [
        { text: 'Tipo', value: 'description', align: 'center', sortable: false },
        { text: 'Razón', value: 'value', align: 'center', sortable: false }
    ];

    headersStops: any[] = [
        { text: 'Vehiculo', value: 'vehicle', align: 'center', width: '126px' },
        { text: 'Tipo', value: 'type', align: 'center', sortable: false },
        { text: 'Inicio', value: 'datetime_from', align: 'center', formatter: this.parseDate, width: '180px' },
        { text: 'Fin', value: 'datetime_to', align: 'center', formatter: this.parseDate, width: '180px' },
        { text: 'Duración', value: 'duration', align: 'center', sortable: false },
        { text: 'Ubicación', value: 'location', align: 'center' }
    ];

    headersPeriod: any[] = [
        { text: 'Vehículo', value: 'description', align: 'center',  },
        { text: 'Inicio', value: 'datetime_from', align: 'center', formatter: this.parseDate, width: '180px' },
        { text: 'Fin', value: 'datetime_to', align: 'center', formatter: this.parseDate, width: '180px' },
        { text: 'Estado', value: 'state', align: 'center', width: '90px' },
        { text: 'Acciones', value: 'ubication', align: 'center', width: '50px', sortable: false }
    ];

    otsList: Array<object> = [];

    timeInterval: any = null;
    refreshInterval: number = 12000;

    parseDate(value){
        return formatDate(value, false)
    }

    @Destroyed
    removeInterval() {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
    }

    get getFormData() {
        return this.formData
    }

    get fechaTentativaIsSetted() {
        if (this.fechaTentativa !== '') {
            return true;
        } else {
            return false;
        }
    }

    get modalJourney(): HTMLFormElement {
        return this.$refs.modalJourney as HTMLFormElement;
    }

    get getForzarCierreModifyButtonsTitle() {
        //si la jornada finalizó
        if (this.journeyFinished) {
            return 'Modificar datos de esta jornada';
        } else {
            //si la jornada no finalizó y no se está cerrando
            if (!this.journeyProcessingClosing) {
                return 'Forzar cierre de esta jornada';
            } else {
                //si la jornada no finalizó pero se está cerrando
                return 'Se está procesando el cierre de la jornada';
            }
        }
    }

    get getDisabledForzarCierre() {
        //si la jornada no finalizó
        if (!this.journeyFinished) {
            //si la jornada se esta cerrando
            if (this.journeyProcessingClosing) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    get journeyProcessingClosing() {
        if (this.journeyIsClosing && this.journeyDateEnd === '-') {
            return true;
        } else {
            return false;
        }
    }

    get shouldDisplayAlertsSection() {
        if (!this.journeyCreatedByAdmin) {
            return true;
        } else {
            if (this.alerts && this.alerts.count !== 0) {
                return true;
            } else {
                return false;
            }
        }
    }

    get shouldDisplayAlertBox() {
        if (
            this.journeyHasError ||
            this.journeyDeleted ||
            this.journeyProcessingClosing ||
            this.journeyCreatedByAdmin ||
            this.reprocessAlert ||
            this.inconsistency
        ) {
            return true;
        }
        return false;
    }

    get shouldCreateAndRead(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.EDIT_AND_DELETE) ||
            this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.CREATE)
        );
    }

    get isMdpUser(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.MDP] == true;
    }

    get getModalData() {
        if (!this.journeyFinished) {
            return this.modalForzarCierreInfo;
        } else {
            return this.modalEditarDatos;
        }
    }

    updateJourneyStatus(event) {
        if (event === 'DELETED') {
            this.journeyDeleted = true;
        } else if (event === 'UNDELETED') {
            this.journeyDeleted = false;
        }
    }

    get modalAbmVisibility() {
        return this.showModalAbm;
    }

    volverAlListado() {
        this.$router.push(NAME_ROUTES.JOURNEYSLIST.path);
    }

    get journeyProcessed() {
        return this.$_getJourneyStatus;
    }

    get journeyHasError() {
        return this.$_getJourneyError;
    }

    @Watch('$_getPrivileges', { immediate: true, deep: true })
    watchPrivileges(value:Privileges) {
        if (value.journey_only_view) {
            this.cantSeeDetail();
        }
    }



    @Watch('journeyProcessingClosing')
    watchProcessingClosing(value) {
        if (value && !this.timeInterval) {
            this.timeInterval = setInterval(() => {
                this.getJourneyData();
            }, this.refreshInterval);
        } else {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            this.pendingRequest = false;
            this.processingRequest = false;
        }
    }

    exportToExcel() {
        this.showModalConfirmation = false;
        this.processingExcel = true;
        let companyId = this.$_getSelectedCompanyById as number;
        let journeysIds = {
            id: this.$route.params.id,
            company_id: companyId
            // id: '5e7c96c5c7cb4911f9298de9' //Jornada erronea para testing
        };
        let fileName =
            'jornada' +
            '-[' +
            this.summary.vehicles.map(vehicle => vehicle.vehicle_plate).toString() +
            '_' +
            this.summary.driver.id +
            ']-' +
            getDateFormattedAsMoment(this.summary.datetime_from, dateTypes.dateFormatFromDisplayInfoHyphenMins)
        generateExcel(journeysIds, fileName, 'detail');
    }
    openModifyjourney() {
        this.showModifyJourney = true;
    }

    @Watch('$_getVehiclesFromSelectedCompanySorted')
    watchVehiclesFromSelectedCompany(items) {
        if (items.length > 0) {
            this.preselectVehicleInModalEditar();
        }
    }

    @Watch('$route', { immediate: true, deep: true })
    onUrlChange(newVal: any) {
        EventBus.$emit(TypeEventBus.NOT_CALL_LAST_REPORT);
    }

    @Watch('journeyCompanyId')
    observableCompanyId(companyId){
        this.getDriversFromSelectedCompany(companyId);
    }

    getDriversFromSelectedCompany(companyId) {
        SettingsService.getDriversList(companyId as string, false, false)
            .then(data => {
                let drivers: any = data;
                this.$_setDriversCompany(drivers.sort(sortObjectByPropertyName('name')));
            })
            .catch(err => {
                this.$_setDriversCompany(null);
            });
    }


    showPeriodInMap(period) {
        this.setJourneyInfo(period.vehicle_id, period);
        this.$router.push(NAME_ROUTES.TRACKING);
    }

    closeModalJourney() {
        this.showModalAbm = false;
    }

    processJourney() {
        this.processingRequest = true;
        this.showModalConfirmation = false;
        if (this.journeyProcessed) {
            //Si la jornada esta procesada
            //Marcar como no procesada
            this.actionJourney = 'unprocess';
            this.postJson = { action: 'unprocess', journey_list:[this.$route.params.id] };
            this.showConfirmationModal(true);
        } else {
            //Si la jornada no está procesada
            //Marcar como procesada
            this.actionJourney = 'process';
            this.postJson = { action: 'process', journey_list: [this.$route.params.id] };
            this.showConfirmationModal(true);
        }
    }

    getHoursFromTimeDelta(time) {
        let hours = time.split('H');
        return hours[0];
    }

    formatDataModalEditJourney(data) {
        let driver = data.summary.driver.id;
        //let vehicle = data.summary.vehicle.vehicle_plate;
        //this.vehicleSelected = vehicle;
        
        let simpleHours = data.hours && data.hours.simples ? data.hours.simples.value.toString() : this.defaultTimeValue;
        let nightHours = data.hours && data.hours.night ? data.hours.night.value.toString() : this.defaultTimeValue
        let extraHours = data.hours && data.hours.extra ? data.hours.extra.value.toString() : this.defaultTimeValue
        let simplePresence = data.hours && data.hours.simple_presence_time ? data.hours.simple_presence_time.value.toString() : this.defaultTimeValue
        let overnightHours = data.hours && data.hours.overnight ? data.hours.overnight.value.toString() : this.defaultTimeValue
        let simpleSpecialHours = data.hours && data.hours.simple_special ? data.hours.simple_special.value.toString() : this.defaultTimeValue
        let extraSpecialHours = data.hours && data.hours.extra_special ? data.hours.extra_special.value.toString() : this.defaultTimeValue
        let extraRestHours = data.hours && data.hours.extra_rest ? data.hours.extra_rest.value.toString() : this.defaultTimeValue
        let simpleRestHours = data.hours && data.hours.simple_rest ? data.hours.simple_rest.value.toString() : this.defaultTimeValue
        let stoppedTimeHours = data.hours && data.hours.vehicle_stopped_time ? data.hours.vehicle_stopped_time.value.toString() : this.defaultTimeValue
        

        let closed_segments = data.closed_segments;
        let summary = data.summary;
        //Preselect driver
        this.formData['driver'] = this.getDriverInList(driver) ? this.getDriverInList(driver) : false;
        if (!this.formData['driver']) {
            let newDriver = {
                availability: true,
                ci: driver,
                company: this.$_getSelectedCompanyById,
                name: driver.toString(),
                phone_number: '29999999',
                tag: driver
            };
            let oldDriverList = this.$_getDriversFromSelectedCompany;
            let newItemIndex = Object.keys(oldDriverList).length + 1;
            let newObj = { [newItemIndex]: newDriver };
            let driverList: any = Object.assign(oldDriverList, newObj);
            this.$_setDriversCompany(driverList);
            this.formData['driver'] = this.getDriverInList(newDriver.ci);
        }
        this.formData['dateStart'] = getDateFormattedAsMoment(data.summary.datetime_from,dateTypes.dateYearFormatReverse, dateTypes.globalFilterDateFormatNoSeconds) 
        this.formData['hourStart'] = getDateFormattedAsMoment(data.summary.datetime_from, dateTypes.hoursAndMinutesFormat, dateTypes.globalFilterDateFormatNoSeconds)
        
        //set hours
        this.formData.simpleHours['hours'] = this.getHoursFromTimeDelta(simpleHours);
        this.formData.simpleHours['minutes'] = this.getMinsFromTimeDelta(simpleHours);
        this.formData.nightHours['hours'] = this.getHoursFromTimeDelta(nightHours);
        this.formData.nightHours['minutes'] = this.getMinsFromTimeDelta(nightHours);
        this.formData.extraHours['hours'] = this.getHoursFromTimeDelta(extraHours);
        this.formData.extraHours['minutes'] = this.getMinsFromTimeDelta(extraHours);
        this.formData.simplePresentHours['hours'] = this.getHoursFromTimeDelta(simplePresence);
        this.formData.simplePresentHours['minutes'] = this.getMinsFromTimeDelta(simplePresence);
        this.formData.overnightHours['hours'] = this.getHoursFromTimeDelta(overnightHours);
        this.formData.overnightHours['minutes'] = this.getMinsFromTimeDelta(overnightHours);
        this.formData.simpleSpecialHours['hours'] = this.getHoursFromTimeDelta(simpleSpecialHours);
        this.formData.simpleSpecialHours['minutes'] = this.getMinsFromTimeDelta(simpleSpecialHours);
        this.formData.extraSpecialHours['hours'] = this.getHoursFromTimeDelta(extraSpecialHours);
        this.formData.extraSpecialHours['minutes'] = this.getMinsFromTimeDelta(extraSpecialHours);
        this.formData.extraRestHours['hours'] = this.getHoursFromTimeDelta(extraRestHours);
        this.formData.extraRestHours['minutes'] = this.getMinsFromTimeDelta(extraRestHours);
        this.formData.simpleRestHours['hours'] = this.getHoursFromTimeDelta(simpleRestHours);
        this.formData.simpleRestHours['minutes'] = this.getMinsFromTimeDelta(simpleRestHours);
        this.formData.stoppedTimeHours['hours'] = this.getHoursFromTimeDelta(stoppedTimeHours);
        this.formData.stoppedTimeHours['minutes'] = this.getMinsFromTimeDelta(stoppedTimeHours);

        this.formData.closed_segments = closed_segments;
        this.formData.summary = summary;

        let timeDeltaHours =
            parseInt(this.formData.simpleHours['hours']) +
            parseInt(this.formData.nightHours['hours']) +
            parseInt(this.formData.extraHours['hours']) +
            parseInt(this.formData.simplePresentHours['hours']) +
            parseInt(this.formData.overnightHours['hours'])+
            parseInt(this.formData.simpleSpecialHours['hours']) +
            parseInt(this.formData.extraSpecialHours['hours'])+
            parseInt(this.formData.extraRestHours['hours']) +
            parseInt(this.formData.simpleRestHours['hours']);
            parseInt(this.formData.stoppedTimeHours['hours']);
        let timeDeltaMinutes =
            parseInt(this.formData.simpleHours['minutes']) +
            parseInt(this.formData.nightHours['minutes']) +
            parseInt(this.formData.extraHours['minutes']) +
            parseInt(this.formData.simplePresentHours['minutes']) +
            parseInt(this.formData.overnightHours['minutes']) +
            parseInt(this.formData.simpleSpecialHours['minutes']) +
            parseInt(this.formData.extraSpecialHours['minutes']) +
            parseInt(this.formData.extraRestHours['minutes'])
            parseInt(this.formData.simpleRestHours['minutes'])
            parseInt(this.formData.stoppedTimeHours['minutes'])

        let startDate = getDateAsMoment(data.summary.datetime_from.slice(0, -3), dateTypes.globalFilterDateFormatNoSeconds);
        let dateEnd = addTimeToDate(startDate, { hours: timeDeltaHours, minutes: timeDeltaMinutes })
        this.formData['hourEnd'] = getDateFormattedAsMoment(dateEnd, dateTypes.hoursAndMinutesFormat, dateTypes.globalFilterDateFormatNoSeconds) 
        this.formData['dateEnd'] = getDateFormattedAsMoment(dateEnd,dateTypes.dateYearFormatReverse, dateTypes.globalFilterDateFormatNoSeconds)

        if (this.showModalAbm) {
            this.modalJourney.updateFormData(this.formData);
        }
        this.stopLoading();
    }

    preselectVehicleInModalEditar() {
        let keys = Object.keys(this.$_getVehiclesFromSelectedCompanySorted);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (this.$_getVehiclesFromSelectedCompanySorted[keys[i]].vehicle_plate === this.vehicleSelected) {
                this.formData['vehicle'] = this.$_getVehiclesFromSelectedCompanySorted[keys[i]];
            }
        }
    }

    @Watch('$_getSelectedCompany')
    observableSelectedCompany(value) {
        this.$_setSelectedVehicles([]);
    }

    getDriverInList(driver) {
        let keys = Object.keys(this.$_getDriversFromSelectedCompany);
        for (let i = 0, len = keys.length; i < len; i++) {
            if (
                this.$_getDriversFromSelectedCompany[keys[i]].ci === driver ||
                this.$_getDriversFromSelectedCompany[keys[i]].name === driver
            ) {
                return this.$_getDriversFromSelectedCompany[keys[i]];
            }
        }
    }

    rightClickJourney(event, period) {
        this.updateDateRange(period);
        removeItemFromLocalStorage(StoregeKey.FILTERED_DATE_RANGE);
        this.contextMenuItem = [];
        this.contextMenuItem.push({
            disabled: false,
            title: 'Abrir en una nueva pestaña',
            link: {
                path:
                    '/travel?c_id=' +
                    this.company +
                    '&v_id=' +
                    period.vehicle_id +
                    '&date_start=' +
                    period.datetime_from +
                    '&date_end=' +
                    period.datetime_to,
                target: '_blank'
            }
        });
        this.rightClickEvent = event;
        this.showContextMenu = true;
    }

    closeContextMenu() {
        this.showContextMenu = false;
    }

    getMinsFromTimeDelta(time) {
        let minutes = time
            .split('H')
            .pop()
            .split('M')[0]
            .toString();
        return minutes;
    }

    getSecondsFromTimeDelta(time) {
        let seconds = parseInt(getDateFormattedAsMoment(time, dateTypes.seconds, dateTypes.hoursAndMinutesAndSecondsBrackets));
        return seconds;
    }

    showConfirmationModal(value) {
        this.showModalConfirmation = value;
    }

    marcarComoError() {
        this.showModalConfirmation = false;
        this.processingRequestMark = true;
        if (!this.journeyHasError) {
            this.actionJourney = 'markAsError';
            this.postJson = { action: 'error', journey_list: [this.$route.params.id] };
            this.showConfirmationModal(true);
        } else {
            this.actionJourney = 'unMarkAsError';
            this.postJson = { action: 'noerror', journey_list: [this.$route.params.id] };
            this.showConfirmationModal(true);
        }
    }

    unSelectAllVehicles() {
        let vehiclesMap = this.$_getVehiclesMap;
        let vehicleIds = this.$_getSelectedVehiclesByID;
        for (let i = 0; i < vehicleIds.length; i++) {
            this.$_unSelectVehicle(vehiclesMap[vehicleIds[i]]);
        }
    }

    selectVehicle(vehicleId: string) {
        let vehiclesMap = this.$_getVehiclesMap;
        this.$_addSelectedVehicle(vehiclesMap[vehicleId]);
    }

    updateDateRange(dateRange) {
        this.$_setTypeFilterDate(TypeFilterDate.RANGE_DATE);
        this.$_setDateRange(dateRange);
        setTimeout(() => {
            EventBus.$emit(TypeEventBus.CLOSE_DATEPICKER_POPUP);
        }, 1000);
    }

    setJourneyInfo(vehicleId: string, period) {
        this.unSelectAllVehicles();
        this.selectVehicle(vehicleId);
        this.updateDateRange(period);
    }

    handleCloseModifyjourney(confirm: boolean) {
        this.showModifyJourney = false;
    }

    mounted() {
        
        this.setModalEditarData();
        EventBus.$on(TypeEventBus.REMOVE_COMMENTARY_DELETED, id => {
            this.showModalConfirmation = false;
            this.journeyEvents = this.journeyEvents.filter(function(obj) {
                return obj.id !== id;
            });
            EventBus.$emit(TypeEventBus.COMMENTARY_DELETED_FROM_LIST);
        });

        EventBus.$on(TypeEventBus.OPEN_MODAL_CONFIRMATION, action => {
            this.showModalConfirmation = false;
            this.actionJourney = action;
            this.showModalConfirmation = true;
        });
        EventBus.$on(TypeEventBus.CLOSE_MODAL_CONFIRMATION, () => {
            this.processingRequest = false;
            this.processingRequestMark = false;
            this.showModalConfirmation = false;
        });

        this.cancelToken = Axios.CancelToken.source();
        if(this.shouldSeeJourneyDetail){
            this.getJourneyData();
            this.getJourneyEvents();
        }
        
        EventBus.$on(TypeEventBus.EXCEL_EXPORT_ERROR, () => {
            this.processingExcel = false;
            this.actionJourney = 'errorExportExcel';
            this.showModalConfirmation = true;
        });
        EventBus.$on(TypeEventBus.EXCEL_GENERATED, () => {
            this.processingExcel = false;
        });
    }

    openConfirmationDialog(action) {
        this.actionJourney = action;
        this.showModalConfirmation = true;
    }

    getDriverInfo(driverData: object){
        let driverName = driverData['name'] !== null ? driverData['name'] : '-';
        let driverCI = driverData['ci'] !== null ? driverData['ci'] : driverData['id'] !== null ? driverData['id'] : '-';
        let driverPhoneNumber = driverData['phone_number'] !== null ? driverData['phone_number'] : '-';
        return `
                <span>Nombre: ${driverName}</span><br>
                <span>CI: ${driverCI}</span><br>
                <span>Teléfono: ${driverPhoneNumber}</span>
            `

    }

    

    get shouldSeeJourneyDetail(): boolean {
        let canSeeJourneyDetail = this.$_getPrivileges[PRIVILEGE_KEYS.JOURNEY_ONLY_VIEW] == false
        return canSeeJourneyDetail
    }

    cantSeeDetail(){
        this.$_showHistoricalError('No tienes permisos para ver el detalle de la jornada');
        if(this.cancelToken){
            this.cancelToken.cancel();
        }
        this.pendingRequest = false;
        this.volverAlListado();
    }
       
    getJourneyData() {
        this.pendingRequest = true;
        this.$_setJourneyError(false);
        this.formData = this.defaultFormData;

        if(!this.shouldSeeJourneyDetail){
            this.cantSeeDetail();
            return;
        }

        JourneysService.getJourneyInformation(this.$route.params.id, false, this.cancelToken)
            .then(data => {
                
                this.assignJourneyInformation(data);
                this.showModalAbm = false;
                this.pendingRequest = false;
                this.processingRequest = false;
            })
            .catch(error => {
                if (error && error.response && error.response.status !== 200) {
                    let message;
                    if (error && error.response && error.response.data && error.response.data.non_field_errors) {
                        message = error.response.data.non_field_errors[0];
                    } else {
                        message = 'La jornada seleccionada no se encuentra';
                    }
                    this.$_showHistoricalError(message);
                    this.journeyEvents = [];

                    setTimeout(() => {
                        this.volverAlListado();
                    }, 1200);

                    this.pendingRequest = false;
                    this.processingRequest = false;
                }
            });
    }

    assignJourneyInformation(data) {
        let defaultData = JSON.parse(JSON.stringify(data));
        this.formData = this.defaultFormData;
        this.pendingRequest = true;
        this.journeyIsClosing = data.closing;
        this.journeyCreatedByAdmin = data.created;
        this.journeyHasPernocte = data.pernocte;
        this.journeyCompanyId = data.company;
        this.stats = data.stats;
        this.hours = data.hours;
        this.alarms = data.alarms;
        this.journeyDeleted = data.deleted;
        
        this.reprocessAlert = data.summary.reprocess_alert;
        this.journeyFinished = data.summary.finished;
        this.journeyStatus = data.processed;
        this.inconsistency = data.inconsistency;
        this.journeyReports = this.getReportsDataFormatted(data);
        this.$_setJourneyError(data.error);
        this.$_setJourneyStatus(data.processed);
        if(this.journeyDeleted){
            this.deletedTooltip = data.deleted_text;
        }
        for (let i = 0; i < data.stops.length; i++) {
            data.stops[i].duration = this.formatStopDuration(data.stops[i].duration);
            data.stops[i]['type'] = 'simple';
        }
        this.stops = data.stops;

        if (data.pernocte !== null) {
            this.stops.push({
                datetime_from: data.pernocte.datetime_from,
                datetime_to: data.pernocte.datetime_to,
                duration: this.formatStopDuration(data.pernocte.duration),
                location: data.pernocte.location == null ? '-' : data.pernocte.location,
                type: 'pernocte'
            });
            // TODO: Hay que cambiar este codigo cuando se quieran tener en cuenta multiples pernoctes
            const indexOfPercnote = getIndexFromList(data.stops, 'type', 'pernocte')
            this.stops[indexOfPercnote].vehicle = data.pernocte.vehicle;
        }

        this.summary = data.summary;
        if(this.summary['calc_type']){
            this.journeyCalcType = this.summary['calc_type']['value'];
        }
        this.journeyDateEnd = this.format(data.summary.datetime_to);
        this.alerts = data.summary.alerts;
        this.periods = this.getParsedClosedSegments(data);
        // this.otsList = data.ots;
        this.otsList = data.work_orders;
        
        
        // this.otsList= this.harcodedOtsList;
        this.company = data.company;

        if (this.journeyFinished) {
            this.showActions = true;
            this.backupJourneyInformation = defaultData;
            this.formatDataModalEditJourney(data);
        } else {
            if (!this.journeyProcessingClosing) {
                this.getJourneyEstimatedClose();
            } else {
                this.showActions = true;
            }
        }
        this.pendingRequest = false;
    }

    getReportsDataFormatted(data){
        let dataReportsHasData = data.reports['state_report']['data'] !== null ? true : false;
        if(!dataReportsHasData){
            return data.reports
        }else{
            let vehiclesKeys = Object.keys(data.reports['state_report']['data']);
            if(vehiclesKeys.length == 0){
                return data.reports
            }else{
                let vehiclesValues:any = Object.values(data.reports['state_report']['data']);
                for (let index = 0; index < vehiclesValues.length; index++) {
                    for (let b = 0; b <  vehiclesValues[index].length; b++) {
                        vehiclesValues[index][b]['vehicle_index'] = index
                    }
                }
                return data.reports
            }
        }
        
    }

    getJourneyVehicleFromVehicleId(journey, vehicleId) {
        return journey.summary.vehicles.find(vehicle => vehicle.id === vehicleId);
    }

    getParsedSegment(journey, segment) {
        const vehicle = this.getJourneyVehicleFromVehicleId(journey, segment.vehicle_id);
        return {
            ...segment,
            description: vehicle.description
        };
    }

    getParsedClosedSegments(journey) {
        let closedSegments = journey['closed_segments'].map(function(segment) {
            return {
                ...segment,
                state: 'Cerrado'
            };
        });
        let openSegments = journey['open_segments'].map(function(segment) {
            return {
                ...segment,
                datetime_to: segment['last_moving'],
                state: 'Abierto'
            };
        });
        let allSegments = [...closedSegments, ...openSegments];
        return allSegments.map(segment => this.getParsedSegment(journey, segment));
    }

    get getShowActions() {
        return this.showActions;
    }
    stopLoading() {
        this.pendingRequest = false;
        this.processingRequest = false;
    }

    getJourneyEstimatedClose() {
        this.cancelToken = Axios.CancelToken.source();
        JourneysService.getJourneyEstimatedClose(this.$route.params.id, false, this.cancelToken)
            .then(data => {
                if (data && data.datetime_to) {
                    this.fechaTentativa = getDateFormattedAsMoment(data.datetime_to, dateTypes.dateFormatFromDisplayInfoBrackets, dateTypes.globalFilterDateFormat)
                    this.setModalForzarCierreDisclaimers();
                    this.stopLoading();
                    this.showActions = true;
                } else {
                    this.fechaTentativa = this.actualTimeStamp;
                    this.setModalForzarCierreDisclaimers();
                    this.stopLoading();
                    this.showActions = true;
                }
            })
            .catch(error => {
                this.fechaTentativa = this.actualTimeStamp;
                this.setModalForzarCierreDisclaimers();
                this.stopLoading();
                this.showActions = true;
            });
    }

    setModalForzarCierreDisclaimers() {
        this.modalForzarCierreInfo['disclaimers'] = [
            'El cierre de la jornada se forzará en el último valor encendido al momento del cierre.',
            'En caso de que el vehículo se encuentre en movimiento, la jornada se cerrara \n en el momento solicitado  y se abrirá una nueva jornada.',
            'Si desea modificar la fecha de la jornada, debera realizar la modificación <br> luego de cerrada la misma.',
            'Fecha <b>tentativa</b> de cierre forzado de jornada: ' + '<b>' + this.fechaTentativa + '</b>'
        ];
    }

    setModalEditarData() {
        this.$set(this.formData, 'driver', '');
        this.$set(this.formData, 'vehicle', '');
        this.$set(this.formData, 'dateStart', '');
        this.$set(this.formData, 'hourStart', null);
        this.$set(this.formData, 'dateEnd', null);
        this.$set(this.formData, 'hourEnd', null);
        this.$set(this.formData.simpleHours, 'hours', null);
        this.$set(this.formData.simpleHours, 'minutes', null);
        this.$set(this.formData.nightHours, 'hours', null);
        this.$set(this.formData.nightHours, 'minutes', null);
        this.$set(this.formData.extraHours, 'hours', null);
        this.$set(this.formData.extraHours, 'minutes', null);
        this.$set(this.formData.simplePresentHours, 'hours', null);
        this.$set(this.formData.simplePresentHours, 'minutes', null);
        this.$set(this.formData.overnightHours, 'hours', null);
        this.$set(this.formData.overnightHours, 'minutes', null);
        this.$set(this.formData.simpleSpecialHours, 'hours', null);
        this.$set(this.formData.simpleSpecialHours, 'minutes', null);
        this.$set(this.formData.extraSpecialHours, 'hours', null);
        this.$set(this.formData.extraSpecialHours, 'minutes', null);
        this.$set(this.formData.extraRestHours, 'hours', null);
        this.$set(this.formData.extraRestHours, 'minutes', null);
        this.$set(this.formData.stoppedTimeHours, 'hours', null);
        this.$set(this.formData.stoppedTimeHours, 'minutes', null);
    }

    getJourneyEvents() {
        EventBus.$emit(TypeEventBus.PROCESSING_EVENTS);
        let _this = this;
        JourneysService.getJourneyConfigurationList(this.$route.params.id, false, this.cancelToken)
            .then(response => {
                _this.filterEvents(response);
                _this.stopLoading();
            })
            .catch(error => {
                _this.stopLoading();
                // _this.checkCatchResponse(error.response);
            });
    }

    filterEvents(response) {
        let arrayReverse = response.reverse();
        if (arrayReverse.length > 0) {
            this.journeyEvents = arrayReverse;
        } else {
            this.journeyEvents = [];
        }
        EventBus.$emit(TypeEventBus.EVENTS_REFRESHED, response, false);
    }

    formatStopDuration(time) {
        let newTime = time.slice(0, -3);
        let getHoras = parseInt(newTime.slice(0, 2));
        let getMinutos = newTime.slice(3);
        let formattedTime;

        if (getHoras == 0) {
            formattedTime = getMinutos.replace('M', 'm');
        } else {
            formattedTime = getHoras + 'h ' + getMinutos.replace('M', 'm');
        }
        return formattedTime;
    }

    getHoursFromTimeStamp(timestamp) {
        return parseInt(getDateFormattedAsMoment(timestamp, dateTypes.hoursAndMinutesFormat));
    }

    getHoursFromRegExp(input: string) {
        if (typeof input !== 'string') {
            return input;
        } else {
            let regexp = /(\d{1,})H(\d{1,})M(\d{1,})S/;
            if (!regexp.test(input)) {
                return input;
            } else {
                let hours = regexp.exec(input);
                if (hours && hours[0] != null && hours[1] != null && hours[2] != null) {
                    if (parseInt(hours[2]) === 0) {
                        return parseInt(hours[1]) + 'h';
                    } else {
                        return parseInt(hours[1]) + 'h ' + parseInt(hours[2]) + 'm';
                    }
                } else {
                    return '-';
                }
            }
        }
    }

    format(date: string) {
        return formatDate(date);
    }
}
